<div class="full">
  <section class="content title-tire-specification subtitle-tire-specification" [innerHTML]="sanitizedContent(dataSignal())"></section>
</div>
